export default "__VITE_PUBLIC_ASSET__c9f1b7f3__"